<div class="cat-table-container pop-datatable rem-fix">
  <pop-loading *ngIf="isLoading">
  </pop-loading>
  <p-table #ct
           [value]="categories"
           [globalFilterFields]="['code', 'description']"
           frozenWidth="13em"
           [columns]="scrollableCols"
           [scrollable]="true"
           scrollHeight="flex"
           [frozenColumns]="frozenCols"
           scrollDirection="both">
    <ng-template pTemplate="header"
                 let-columns>
      <tr>
        <th class="cat-table-top-header"
            colspan="1"
            pFrozenColumn>
          <i class="far fa-search"></i>
          <input class="input-filter"
                 type="text"
                 pInputText
                 size="50"
                 (input)="filterTable(ct, $event.target)" />
        </th>
        <th class="cat-table-top-header pop-text-align-center"
            [attr.colspan]="colspanClassification"
            [hidden]="colspanClassification === 0"
            translate="TOOLBAR.CLASS"></th>
        <th class="cat-table-top-header cat-alignCenter"
            colspan="4"
            translate="HEADER.HOURS"></th>
        <th class="cat-table-top-header cat-alignCenter"
            [attr.colspan]="4+colspanInternalFees"
            *ngIf="activateInternalFees"
            translate="HEADER.INTERNAL_FEES"></th>
        <th class="cat-table-top-header cat-alignCenter"
            colspan="3"
            translate="HEADER.EXPENSE"></th>
        <th class="cat-table-top-header cat-alignCenter"
            colspan="3"
            translate="HEADER.TOTALS"></th>
      </tr>
      <tr>
        <th class="cat-table-pro-header pop-border-right"
            pFrozenColumn
            translate="HEADER.CATEGORY"></th>
        <th class="class-header cat-alignCenter"
            [hidden]="colspanClassification === 0"
            *ngFor="
            let classificationEstimate of currentEstimate.classificationEstimates
          ">
          <div class="pop-display-flex pop-flex-direction-column">
            <span>{{ classificationEstimate?.classification?.code }}</span>
            <span class="cat-class-description">
              {{
              classificationEstimate?.classification?.description
              }}
            </span>
          </div>
        </th>
        <th class="hours-header cat-alignCenter pop-border-left"
            translate="HEADER.HOURS"></th>
        <th class="total-cost-header cat-alignCenter">
          {{ "TABLE.COSTING" | translate }} ({{ functionalCurrencySymbol }})
        </th>
        <th class="total-s-header cat-alignCenter">
          {{ "TABLE.SELLING" | translate }} ({{ functionalCurrencySymbol }})
        </th>
        <th class="total-s-header cat-alignCenter pop-border-right">
          {{ "TABLE.TOTAL_SELLING" | translate }} ({{ functionalCurrencySymbol }})
        </th>

        <ng-container *ngIf="activateInternalFees">
          <th class="class-header cat-alignCenter"
              [hidden]="colspanClassification === 0"
              *ngFor="
            let internalResourceEstimate of currentEstimate.internalResourceEstimates
          ">
            <div class="pop-display-flex pop-flex-direction-column">
              <span>{{ internalResourceEstimate?.internalResource?.code }}</span>
              <span class="cat-internalfee-description">
                {{
                internalResourceEstimate?.internalResource?.description
                }}
              </span>
            </div>
          </th>
          <th class="costs-header dep-alignCenter pop-border-left"
              translate="HEADER.QUANTITY"></th>
          <th class="costs-header dep-alignCenter">
            {{ "TABLE.COSTING" | translate }} ({{ functionalCurrencySymbol }})
          </th>
          <th class="total-s-header dep-alignCenter">
            {{ "TABLE.SELLING" | translate }} ({{ functionalCurrencySymbol }})
          </th>
          <th class="total-s-header dep-alignCenter pop-border-right">
            {{ "TABLE.TOTAL_SELLING" | translate }} ({{ functionalCurrencySymbol }})
          </th>
        </ng-container>

        <th class="costs-header cat-alignCenter">
          {{ "TABLE.COSTING" | translate }} ({{ functionalCurrencySymbol }})
        </th>
        <th class="total-s-header cat-alignCenter">
          {{ "TABLE.SELLING" | translate }} ({{ functionalCurrencySymbol }})
        </th>
        <th class="total-s-header cat-alignCenter pop-border-right">
          {{ "TABLE.TOTAL_SELLING" | translate }} ({{ functionalCurrencySymbol }})
        </th>
        <th class="costing-header pop-text-align-center cat-alignCenter">
          {{ "TABLE.COSTING" | translate }} ({{ functionalCurrencySymbol }})
        </th>
        <th class="selling-header cat-alignCenter">
          {{ "TABLE.SELLING" | translate }} ({{ functionalCurrencySymbol }})
        </th>
        <th class="final-selling-header cat-alignCenter">
          {{ "TABLE.TOTAL_SELLING" | translate }} ({{ functionalCurrencySymbol }})
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body"
                 let-rowData
                 let-columns="columns">
      <tr>
        <td class="cat-table-list"
            pFrozenColumn>
          {{ rowData.code }} &#8901; {{ rowData.description }}
        </td>
        <td class="cat-hour-list"
            *ngFor="
            let classificationEstimate of currentEstimate.classificationEstimates
          ">
          {{
          rowData.id
          | categoryHours
          : classificationEstimate.id
          : currentEstimate.structures
          | number: "1.2-2":currentLang
          }}
        </td>
        <td class="cat-total-hour-list">
          {{ rowData | categoryTotalHours | number: "1.2-2":currentLang }}
        </td>
        <td class="cat-hour-list pop-text-align-right">
          {{ rowData | categoryCost | number: "1.2-2":currentLang }}
        </td>
        <td class="cat-hour-list pop-text-align-right">
          {{ rowData | categoryBillable | number: "1.2-2":currentLang }}
        </td>
        <td class="cat-hour-list pop-border-right pop-text-align-right">
          {{ rowData | categoryBillableFinal | number: "1.2-2":currentLang }}
        </td>

        <ng-container *ngIf="activateInternalFees">
          <td class="cat-hour-list pop-text-align-center"
              *ngFor="
              let internalResourceEstimate of currentEstimate.internalResourceEstimates
            ">
            {{ rowData | internalFeeQuantity: internalResourceEstimate.id }}
          </td>
          <td class="cat-table-costing-list pop-text-align-center">
            {{ rowData | internalFeeQuantity }}
          </td>
          <td class="cat-hour-list pop-text-align-right">
            {{ rowData | internalFeeCost | number: "1.2-2":currentLang }}
          </td>
          <td class="cat-hour-list pop-text-align-right">
            {{ rowData | internalFeeBillable | number: "1.2-2":currentLang }}
          </td>
          <td class="cat-hour-list pop-text-align-right">
            {{ rowData | internalFeeBillableFinal | number: "1.2-2":currentLang }}
          </td>
        </ng-container>

        <td class="cat-table-costing-list pop-text-align-right">
          {{ rowData | categoryExpenseCost | number: "1.2-2":currentLang }}
        </td>
        <td class="cat-hour-list pop-text-align-right">
          {{ rowData | categoryExpenseBillable | number: "1.2-2":currentLang }}
        </td>
        <td class="cat-hour-list pop-text-align-right">
          {{
          rowData | categoryExpenseBillableFinal | number: "1.2-2":currentLang
          }}
        </td>
        <td class="cat-table-costing-list pop-text-align-right">
          {{
          (rowData | categoryCost) + (rowData | categoryExpenseCost) + (rowData | internalFeeCost)
          | number: "1.2-2":currentLang
          }}
        </td>
        <td class="cat-hour-list pop-text-align-right">
          {{
          (rowData | categoryBillable) + (rowData | categoryExpenseBillable) + (rowData | internalFeeBillable)
          | number: "1.2-2":currentLang
          }}
        </td>
        <td class="cat-hour-list pop-text-align-right">
          {{
          (rowData | categoryBillableFinal) +
          (rowData | categoryExpenseBillableFinal) + (rowData | internalFeeBillableFinal)
          | number: "1.2-2":currentLang
          }}
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
